/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ ok: NonNullable<unknown>, total: NonNullable<unknown> }} Rd_PassedInputs */

const en_rd_passed = /** @type {(inputs: Rd_PassedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.ok} of ${i?.total} checks passed`)
};

const id_rd_passed = /** @type {(inputs: Rd_PassedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.ok} dari ${i?.total} cek lolos`)
};

/**
* | output |
* | --- |
* | "{ok} of {total} checks passed" |
*
* @param {Rd_PassedInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const rd_passed = /** @type {((inputs: Rd_PassedInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rd_PassedInputs, { locale?: "en" | "id" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_rd_passed(inputs)
	return en_rd_passed(inputs)
});